import { useMemo } from 'react';
import { chain, filter } from 'lodash';
import { useLocalStorageState } from '../../../../hooks/useLocalStorageState';
/**
 * A hook that provides the state for the column selector.
 */
export const useColumnSelectorState = ({ allColumnList, defaultColumnKeyList = chain(allColumnList)
    .map(c => c.key)
    .uniq()
    .value(), parentStorageKey, }) => {
    const storageKey = useMemo(() => `${parentStorageKey}-columns`, [parentStorageKey]);
    const [selectedKeyList, setSelectedKeyList] = useLocalStorageState(storageKey, defaultColumnKeyList);
    const selectedColumnList = useMemo(() => filter(allColumnList, w => selectedKeyList && selectedKeyList.indexOf(w.key) > -1), [allColumnList, selectedKeyList]);
    return {
        selectedKeyList,
        setSelectedKeyList,
        selectedColumnList,
    };
};
